<script setup>
import TheRating from '@/components/Layout/Components/Footer/TheRating.vue';
import { formStore } from '@/stores/form.js';

const { ktv } = formStore();
</script>

<template>
  <footer class="footer">
    <!-- rating -->
    <TheRating
      :number-of-reviews="ktv.aantal_beoordelingen"
      :rating="ktv.rating"
    />
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;
  bottom: 0;
}
</style>
